import type { ModuleSlug } from '@features/settings/models'
import { useSettingsStore } from '@features/settings/stores/useSettingsStore'
import { getModuleAccess } from '../logic/moduleAccess'

/** False while the catalog is unknown, so gated entry points never flash in. */
export function useIsModuleEnabled(moduleSlug: ModuleSlug): boolean {
  return useSettingsStore((state) => getModuleAccess(state.modules, moduleSlug).available)
}
